import { AccessSectionConnected } from '@/features/settings/connected'

export default function SettingsPermissionsPage() {
  return <AccessSectionConnected />
}
